import { createContext } from 'react';

interface TabContextProps {
    variant: 'transparent' | 'solid';
    setCurrentId: (v: string) =>void;
}

const TabContext = createContext<TabContextProps>({} as TabContextProps);

export default TabContext;
